import { overlay, accountHelpWindow, ResetPassword, ForgotUsername, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, activationResult } from '../login/login.animations';
import { Component, OnInit } from '@angular/core';

import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from '../../services/user.service';
import { Account } from '../../models/account';

@Component({
  selector: 'recovery',
  templateUrl: './recovery.component.html',
  providers: [ UserService ],
  animations: [
	  	overlay,
	  	VerificationEmail,
		RecoverPasswordTab, 
		ForgottenUsernameTab, 
		VerifyEmailTab, 
		recoveryerror,
		accountHelpWindow,
		ResetPassword,
		ForgotUsername,
		activationResult
	]
})
export class RecoveryComponent implements OnInit {

	public accounts: Account;

	constructor(private userService: UserService,
				private router: Router,
				private sanitizer: DomSanitizer,
				private route: ActivatedRoute,
				private location: Location) { }
	
	key: any;
	title: any;
	header: any;
	subtitle: any;
	headerHeight: any;
	headerAlign: any;

	recovery = new Recovery('', '', '');
	recoveryerr: any;
	recoverysuccess: any;

	passwordStrength: number;
	accountstate = false;
	loggedIn: boolean;
	showerror: boolean;


	/**
	* Activate a user with a provided key (ngModel)
	**/
	recover() {
	
		this.accountstate = false;
		if ( this.recovery.password && this.recovery.secondpassword ) {
			if ( this.recovery.key && this.recovery.password == this.recovery.secondpassword ) {

				this.userService.recoverAccount( this.recovery.key, this.recovery.password ).subscribe((resp) =>  {

					if ( resp.code == 200 ) {
						this.recoverysuccess = resp.message;
						this.accountstate = true;
					} else {
						this.recoveryerr = resp.err;
						this.accountstate = false;
					}

				});

			}
		}
	}



	/**
	* Authorize a logged in user to make a purchase
	**/
	authorize() {
		// Send the authorization request
		this.userService.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
			if ( user ) {
				this.loggedIn = true;
				if ( user[0].accountstate == 1 ) this.accountstate = true
			}
		});
	}


	checkPassword() {
		var numbers = new RegExp("[^0-9]");
		var symbols = new RegExp("[^a-z|^A-Z]");
		if ( this.recovery.password == this.recovery.password ) this.passwordStrength = 1;
		if ( symbols.test(this.recovery.password) ) this.passwordStrength = 2;
		if ( numbers.test(this.recovery.password) ) this.passwordStrength = 3;
		return this.passwordStrength;
	}



	/**
	* Application Start
	**/
	/* On with the show */
	ngOnInit() {
		this.authorize();
		this.title = 'Recover your Identity';
		this.headerHeight = '500px';

		this.key = this.route.snapshot.params['id'];
		if (this.key) this.recovery.key = this.key;
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
	}

}

export class Recovery {
	constructor(
		public key: string,
		public password: string,
		public secondpassword: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-recovery/recovery.component.ts